import React from 'react';

const PDFPrinter = ({ pdfUrl }) => {
  const print = () => {
    const pdfFrame = document.createElement('iframe');
    pdfFrame.style.visibility = 'hidden';
    pdfFrame.src = pdfUrl;

    document.body.appendChild(pdfFrame);

    pdfFrame.contentWindow.focus();
    pdfFrame.contentWindow.print();
  };
  return <i className="fas fa-print clickable" onClick={print} title="download" />;
};

export default PDFPrinter;
